import { createRouter, createWebHashHistory} from 'vue-router';
import Layout from '@/layout';

const routes = [
    {
        path: '/',
        component: Layout,
        redirect: '/dashboard',
        children: [
            {
                path: '/dashboard',
                component: () => import("@/views/dashboard/index.vue"),
                name: 'dashboard',
                meta: {
                    title: '控制台',
                    menu_type: 2,
                    is_show: 1
                }
            },
        ]
    },
    {
        path: '/login',
        component: () => import("@/views/login.vue"),
        name: 'login',
    },
    {
		path: '/404',
        component: () => import("@/views/error/404.vue"),
		name: '404',
	},
    {
        path: '/:pathMatch(.*)*',
        component: () => import('@/views/error/404.vue'),
    },
    {
		path:'/redirect',
		component:Layout,
		hidden:true,
		children:[
			{
				path:'/redirect/:path(.*)',
				component: (resolve) => require(['@/views/redirect'], resolve)
			}
		]
	},
]

export default createRouter({
    history: createWebHashHistory(),
    routes
})